import { Link, Box, Checkbox, Stack } from '@mui/material';
import { TermsText } from '../../../core/theme/formComponents';
import { FunctionComponent } from 'react';
import { PRIVACY_POLICY_URL, TERMS_AND_SERVICES_URL } from '../../../utils/constants';


const TermsAndCondition= ({ onCheck, isChecked }: { onCheck?: () => void; isChecked?: boolean; }) => {
  return (
    <Box sx={{
      width: '100%',
      mt: 3,
      mb: { xs: 3, sm: 1 },
      paddingBottom: { xs: '20px', sm: 0 }
    }}>
      <Stack direction={'row'} alignItems={'flex-start'} gap={2}>
      <Checkbox style={{padding:0}} onClick={() => onCheck && onCheck()} checked={isChecked} /> 
      <TermsText variant='button' sx={{ }}>
       By checking this box, you agree to MindRight Health's
        <Link href={TERMS_AND_SERVICES_URL} target="_blank" rel="noreferrer" underline='hover' color='inherit' sx={{ fontWeight: 'bold', display: 'inline-block' }}>
          Terms of Service
        </Link>{' '}
        &{' '}
        <Link href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer" underline='hover' color='inherit' sx={{ fontWeight: 'bold' }}>
          Privacy Policy
        </Link>
        </TermsText>
      </Stack>
    </Box>
  );
};

export default TermsAndCondition;
